import { createBrowserRouter, Navigate } from 'react-router-dom';
import Collect from '@/pages/Collect';
import NotFound from '@/pages/NotFound';

/**
 * 路由表。这个项目只有一个有意义的页面。
 *
 * 路径用 `/c/:token` 而不是 `/collect/:token`：链接要贴进聊天窗口、可能被手抄，
 * 短一点就少一点出错机会。
 */
export const router = createBrowserRouter([
  { path: '/c/:token', element: <Collect /> },
  { path: '/', element: <Navigate to="/404" replace /> },
  { path: '*', element: <NotFound /> },
]);
